<div class="main-modal-container" (swipeleft)="changeImg(1)" (swiperight)="changeImg(-1)">
  
  <span class="close-x" [mat-dialog-close]="true">×</span>

  <div class="info-overlay top">
    <p class="txt-titulo">{{titulo}}</p>
  </div>

  <div class="info-overlay bottom">
    <p class="txt-contador">{{image.position + 1}} de {{gallery.length}}</p>
  </div>

  <div class="content-wrapper">
    
    <button class="nav-btn left" *ngIf="gallery.length > 1" (click)="changeImg(-1)">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0zm3.5 7.5a.5.5 0 0 1 0 1H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5z"/>
      </svg>
    </button>

    <div class="img-frame">
      <img [src]="image.pathComplete" onerror="this.src='./assets/img/default.png'" class="full-img-view" />
    </div>

    <button class="nav-btn right" *ngIf="gallery.length > 1" (click)="changeImg(1)">
      <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="currentColor" viewBox="0 0 16 16">
        <path d="M8 0a8 8 0 1 1 0 16A8 8 0 0 1 8 0zM4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5H4.5z"/>
      </svg>
    </button>

  </div>
</div>